var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"myCharts",staticClass:"myCharts"})
}
var staticRenderFns = []

export { render, staticRenderFns }